import { Injectable } from "@angular/core";
import { DefaultService} from "@psnb/psnb-api";
import { BatteryBalancer } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BatteryBalancerModelService {
  constructor(private powerSupplyService: DefaultService) {
    this.getAllBatteryBalancerModels();
  }

  getAllBatteryBalancerModels() {
    return this.powerSupplyService.getBatteryBalancers().pipe(map(result => result));
  }

  createBatteryBalancer(model: BatteryBalancer) {
    return this.powerSupplyService.createBatteryBalancers(model).pipe(map(result => result));
  }

  updateBatteryBalancer(model: BatteryBalancer) {
    return this.powerSupplyService.updateBatteryBalancer(model).pipe(map(result => result));
  }

  deleteBatteryBalancer(id: number) {
    return this.powerSupplyService.deleteBatteryBalancer(id).pipe(map(result => result));
  }
}
